export const enum PayMethod {
  PayNow = 'PayNow',
  PayLater = 'PayLater',
}